import React from "react"
import trans from "trans"
import { connect } from "react-redux"
import { AxiosResponse } from "axios"
import { RouterType } from "app/components/routes"
import { InlineWidget } from "react-calendly"

import {
    getProjectSettings as apiGetProjectSettings,
    getCategories,
    getProjectCategories,
    saveProjectCategories,
    saveWhoAreYou,
} from "app/helpers/api";

import {
    css,
    Theme,
    Grid,
    Placeholder,
    Heading,
    Icon,
    Div,
    Button,
    TextInput,
    Select,
    Checkbox,
    InputGroup,
} from "@bdfx/mergado-ui-kit";

import {
    eshopId,
    projectId,
    saveProjectSettings as apiSaveProjectSettings,
    addSubscriber,
    saveContactEmail,
} from "app/helpers/api";

import MapProductElements from "./steps/map-product-elements";
import { ALL_OUTPUT_FORMATS_WITHOUT_GIF, COMPRESSIBLE_FORMATS, createNewTemplateForm } from "shape-edit/forms/helpers";
import { selectFormValue, selectFormValues } from "app/reducers/form";
import { autoCompressionOptions } from "settings/components/project-settings";
import { createToast } from "actions";
import toast_factory from "app/helpers/toast_factory";
import { UPDATE_SETTINGS } from "template-edit/reducers";
import Gallery from "./steps/gallery";
import {updateInputValue as change, initForm} from "app/reducers/form";
import { Project, SettingsFormType, Template } from "app/types/model-types";
import { setProjectToStore } from "app/reducers/project";
import { AITemplatType, RENDERED_TYPE_AUTOWMREMOVE, RENDERED_TYPE_BGREMOVE, RENDERED_TYPE_OUTPAINTING, RENDERED_TYPE_UPSCALE } from "products/types";
import { IconOutpainting, IconSimilarity } from "app/icons";
import newTemplate from "template-edit/helpers/newTemplate";
import { DEFAULT_VISUAL_SIMILARITY_N_LIMIT, DEFAULT_VISUAL_SIMILARITY_THRESHOLD } from "template-edit/components/visual-similarity";
import { CategoryType } from "settings/components/project-categories"
import { capitalize } from "lodash"
import { MUSProvider } from "@mus/core"

interface Props {
    close: Function
    showFirstSteps: number
    router: RouterType
    settingsForm: SettingsFormType
    subscribe: string
    contactEmail: string
    project: Project
    change: typeof change
    initForm: typeof initForm
    setProjectToStore: typeof setProjectToStore,
    createToast: typeof createToast,
}

interface State {
    step: number
    categories: CategoryType[]
    projectCategories: number[]
    whoAreYou: string
}

class Content extends React.Component<Props, State> {
    constructor(props) {
        super(props)
    }

    state: State = {
        step: 1,
        categories: null,
        projectCategories: null,
        whoAreYou: this.props.project.who_are_you,
    }

    componentDidMount(): void {
        apiGetProjectSettings()
            .then((response: AxiosResponse<SettingsFormType>) => {
                this.props.initForm('settingsForm', response.data)
            })

        getCategories()
            .then((response: AxiosResponse<CategoryType[]>) => {
                this.setState({ categories: response.data })
            })
            .catch(e => console.error('cannot get categories', e))

        getProjectCategories()
            .then((response: AxiosResponse<number[]>) => {
                this.setState({ projectCategories: response.data })
            })
            .catch(e => console.error('cannot get project categories', e))

        this.props.initForm('newsletter', { email: this.props.project.contact_email ? this.props.project.contact_email : this.props.project.user?.email })    //FIE-793
    }

    setStep = (step: number) => this.setState({ step: step })

    createNewTemplate = (type: AITemplatType) => {
        createNewTemplateForm(type)
        this.props.router.navigate(`/eshop/${eshopId}/project/${projectId}/templates/new`)
        this.props.close()
    }

    createNewVisualSimilarityTemplate = () => {
        const newTemplateForm: Template = {
            ...newTemplate(),
            visual_similarity_enabled: 1,
            visual_similarity_n: DEFAULT_VISUAL_SIMILARITY_N_LIMIT,
            visual_similarity_threshold: DEFAULT_VISUAL_SIMILARITY_THRESHOLD,
            visual_similarity_templateids: [],
        }
        this.props.initForm('templateForm', newTemplateForm)
        this.props.router.navigate(`/eshop/${eshopId}/project/${projectId}/templates/new`)
        this.props.close()
    }

    setWhoAreYou = (whoAreYou: string) => {
        this.setState({ whoAreYou: whoAreYou })
        this.saveWhoAreYou(whoAreYou)
    }
    setProjectCategories = (projectCategories: number[]) => {
        this.setState({ projectCategories: projectCategories })
        this.saveProjectCategories(projectCategories)
    }

    saveProjectCategories = (projectCategories: number[]) => {
        saveProjectCategories(projectCategories)
            .then((response: AxiosResponse<any>) => {
            }).catch(error => {
                console.error('cannot save project categories', error)
            })
    }

    saveWhoAreYou = (whoAreYou: string) => {
        saveWhoAreYou(whoAreYou)
            .then((response: AxiosResponse<any>) => {
            }).catch(error => {
                console.error('cannot save who are you', error)
            })
    }

    render() {
        const { step, categories, projectCategories, whoAreYou } = this.state
        const { settingsForm, subscribe, contactEmail, } = this.props

        const showCompression = COMPRESSIBLE_FORMATS.includes(settingsForm.output_image_format)

        const categoryOptions = categories ? categories.map((c) => {
            return {
                value: c.id,
                label: trans(c.trans_string),
            }
        }) : null

        return (
            <MUSProvider customTheme={{ 'typographyFontFamily': 'Roboto, sans-serif', 'colorPrimary': Theme.blue, 'colorSecondary': '#FFFF' }}>
            <Div>
                <Div backgroundColor={"#3f5b9c"} padding="20px" position="absolute" top="0" left="0" right="0">
                    <Header type="3">{trans("first_steps_title")}</Header>
                </Div>
                <Div padding="20px" overflow="hidden">
                    <Div maxWidth="600px" margin="auto" marginBottom="50px" marginTop="30px">
                        <Grid gap="50px" cols="auto 1fr" valign="center">
                            <Icon type="feedimageeditor" size={100} />
                            <p>
                                {trans("steps_first_perex")}
                            </p>
                        </Grid>
                    </Div>

                    <Div position="relative" maxWidth="1000px" margin="auto">
                        <StyledHeading type={3}>{step}</StyledHeading>

                        <Div maxWidth="800px" margin="auto" overflow="hidden" position="relative">
                            <Grid
                                cols="repeat(12, calc(16.67% - 5px))"
                                gap="10px"
                                style={{
                                    transition: "transform, 0.2s",
                                    transform: `translate3d(${step === 1 ? "calc( -83.33% - 25px)" : step === 2 ? "calc( -66.67% - 12px)" : step === 3 ? "calc(-50% - 6px)" : step === 4 ? "calc(-33.33% - 6px)" : step === 5 ? "calc(-16.67% - 6px)" : 0},0,0)`
                                }}
                            >
                                <Placeholder color={Theme.blue} style={{ opacity: 0.2 }} width={"100%"} height={"2px"} />
                                <Placeholder color={Theme.blue} style={{ opacity: 0.2 }} width={"100%"} height={"2px"} />
                                <Placeholder color={Theme.blue} style={{ opacity: 0.2 }} width={"100%"} height={"2px"} />
                                <Placeholder color={Theme.blue} style={{ opacity: 0.2 }} width={"100%"} height={"2px"} />
                                <Placeholder color={Theme.blue} style={{ opacity: 0.2 }} width={"100%"} height={"2px"} />
                                <Placeholder color={Theme.blue} style={{ opacity: 1 }} width={"100%"} height={"2px"} />
                                <Placeholder color={Theme.blue} style={{ opacity: 0.2 }} width={"100%"} height={"2px"} />
                                <Placeholder color={Theme.blue} style={{ opacity: 0.2 }} width={"100%"} height={"2px"} />
                                <Placeholder color={Theme.blue} style={{ opacity: 0.2 }} width={"100%"} height={"2px"} />
                                <Placeholder color={Theme.blue} style={{ opacity: 0.2 }} width={"100%"} height={"2px"} />
                                <Placeholder color={Theme.blue} style={{ opacity: 0.2 }} width={"100%"} height={"2px"} />
                                <Placeholder color={Theme.blue} style={{ opacity: 0.2 }} width={"100%"} height={"2px"} />
                            </Grid>
                            <br /><br />
                        </Div>
                    </Div>

                    <HeaderGrid step={step}>
                        <Div key={step + "step1"}>
                            <Heading type="4" margin="20px" perex={trans("steps_first_subheader")}>{trans("steps_first_header")}</Heading>
                            <MapProductElements />

                            <Div textAlign="center" padding="50px">
                                <Button size="big" icon="chevron-left-light" simple={true} disabled={true}>{trans("previous")}</Button>
                                <Button size="big" icon="chevron-right-light" color="green" onClick={() => this.setStep(2)}>{trans("next")}</Button>
                            </Div>
                        </Div>

                        <Div key={step + "step2"}>
                            <Heading type="4" margin="20px">{trans("steps_second")}</Heading>
                            <Grid cols="1fr 1fr" gap="20px">
                                <Select
                                    label={trans("output_image_format")}
                                    name='settingsForm.output_image_format'
                                    sublabel={trans("output_image_format_sublabel")}
                                    notClearable={true}
                                    options={ALL_OUTPUT_FORMATS_WITHOUT_GIF.map(outputFromat => ({ value: outputFromat, label: outputFromat }))}
                                />
                                {showCompression ?
                                    <Select
                                        label={trans("auto_compression_to_size")}
                                        sublabel={trans("auto_compression_to_size_sublabel")}
                                        options={autoCompressionOptions}
                                        name="settingsForm.auto_compression_to_size"
                                    /> : null}
                            </Grid>

                            <Div textAlign="center" padding="50px">
                                <Button size="big" icon="chevron-left-light" simple={true} onClick={() => this.setStep(1)}>{trans("previous")}</Button>
                                <Button size="big" icon="chevron-right-light" color="green" onClick={() => {
                                    apiSaveProjectSettings(this.props.settingsForm)
                                        .then((response: any) => {
                                            this.props.createToast(toast_factory(UPDATE_SETTINGS.SUCCESS, response.data))
                                            this.setStep(3)
                                        })
                                        .catch(error => {
                                            this.props.createToast(toast_factory(UPDATE_SETTINGS.ERROR, error))
                                        })
                                }}>{trans("next")}</Button>
                            </Div>
                        </Div>

                        <Div key={step + "step3"}>
                            <Heading type="4" margin="20px">{trans("steps_third")}</Heading>
                            <Grid cols="1fr" gap="20px">
                                <TextInput
                                    name="newsletter.email"
                                    key={step + ""}
                                    type="email"
                                    label={trans("steps_third_email")}
                                    sublabel={trans("steps_third_email_sublabel")}
                                />
                                <div />
                                <Checkbox name="newsletter.subscribe" label={trans("steps_third_subscribe")} />
                            </Grid>

                            <Div textAlign="center" padding="50px">
                                <Button size="big" icon="chevron-left-light" simple={true} onClick={() => this.setStep(2)}>{trans("previous")}</Button>
                                <Button
                                    size="big"
                                    icon="chevron-right-light" color="green"
                                    onClick={() => {
                                        if (contactEmail) {
                                            saveContactEmail(contactEmail)
                                                .then((response: AxiosResponse<Project>) => {
                                                    this.props.setProjectToStore(response.data)
                                                })
                                                .catch(error => {
                                                    console.error('cannot save contact email', error)
                                                })
                                        }
                                        if (subscribe && contactEmail) {
                                            addSubscriber(contactEmail)
                                        }
                                        this.setStep(4)
                                    }}>{trans("next")}</Button>
                            </Div>
                        </Div>

                        <Div key={step + "step4"}>
                            <Heading type="4" margin="20px" perex={trans("online_call")}>{trans("online_call_header")}</Heading>
                                <InlineWidget
                                    url="https://calendly.com/feed-image-editor"
                                    styles={{ height: '700px' }}
                                    utm={{
                                        utmSource: 'fie-app',
                                        utmCampaign: 'first-steps'
                                    }}
                                    prefill={{
                                        name: this.props.project.user?.name,
                                        email: contactEmail
                                }}
                            />

                            <Div textAlign="center" padding="50px">
                                <Button size="big" icon="chevron-left-light" simple={true} onClick={() => this.setStep(3)}>{trans("previous")}</Button>
                                <Button
                                    size="big"
                                    icon="chevron-right-light" color="green"
                                    onClick={() => {
                                        if (contactEmail) {
                                            saveContactEmail(contactEmail)
                                                .then((response: AxiosResponse<Project>) => {
                                                    this.props.setProjectToStore(response.data)
                                                })
                                                .catch(error => {
                                                    console.error('cannot save contact email', error)
                                                })
                                        }
                                        if (subscribe && contactEmail) {
                                            addSubscriber(contactEmail)
                                        }
                                        this.setStep(5)
                                    }}>{trans("next")}</Button>
                            </Div>
                        </Div>

                        <Div key={step + "step5"}>
                            <Heading type="4" margin="20px" perex={trans("steps_who_are_you_subtitle")}>{trans("steps_who_are_you_title")}</Heading>
                            <InputGroup
                                singleChoice={true}
                                hideInput={true}
                                onChange={(value) => this.setWhoAreYou(value)}
                                value={whoAreYou}
                                items={['agency', 'eshop', 'freelancer'].map((item) => {
                                    return {
                                        value: item,
                                        label: trans(item),
                                    }
                                })}
                                style={{
                                    ' .m-radio-wrapper': {
                                        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                                        gridAutoFlow: 'row',
                                    }
                                }}
                            />

                            <Heading type="4" margin="20px" perex={trans("steps_categorization")}>{trans("steps_categorization_title")}</Heading>
                            {categoryOptions &&
                                <InputGroup
                                    singleChoice={true}
                                    hideInput={true}
                                    onChange={(value) => this.setProjectCategories([value])}
                                    value={projectCategories ? projectCategories[0] : null}
                                    items={categoryOptions}
                                    style={{
                                        ' .m-radio-wrapper': {
                                            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                                            gridAutoFlow: 'row',
                                        }
                                    }}
                                />
                            }

                            <Div textAlign="center" padding="50px">
                                <Button size="big" icon="chevron-left-light" simple={true} onClick={() => this.setStep(4)}>{trans("previous")}</Button>
                                <Button
                                    size="big"
                                    icon="chevron-right-light"
                                    color="green"
                                    disabled={!projectCategories || !whoAreYou || !Array.isArray(projectCategories) || typeof projectCategories[0] === 'undefined' || !projectCategories[0]}
                                    onClick={() => this.setStep(6)}>
                                    &nbsp;{trans("next")}
                                </Button>
                            </Div>
                        </Div>

                        <Div key={step + "step6"}>
                            <Heading type="4" margin="20px" perex={trans("steps_create_perex")}>{trans("steps_create_header")}</Heading>

                            <StyledCreateTemplateGrid>
                                <Button simple={true} onClick={() => this.createNewTemplate(null)} size="big">
                                    <div className='icon-div'><Icon type="image-radix" size={30} color="blue" /></div>
                                    <div className='shadow-div'>{trans("steps_create_blank")}</div>
                                </Button>

                                <Button simple={true} onClick={() => this.createNewTemplate(null)} size="big">
                                    <div className='icon-div'><Icon type="dimensions-radix" size={35} color="blue" /></div>
                                    <div className='shadow-div'>{trans("steps_create_resize")}</div>
                                </Button>

                                <Button simple={true} onClick={() => this.createNewTemplate(RENDERED_TYPE_UPSCALE)} size="big">
                                    <div className='icon-div'><Icon type="padding-radix" size={30} color="blue" /></div>
                                    <div className='shadow-div'>{trans("steps_create_upscale")}</div>
                                </Button>

                                <Button simple={true} onClick={() => this.createNewTemplate(RENDERED_TYPE_BGREMOVE)} size="big">
                                    <div className='icon-div'><Icon type="hobby-knife-radix" size={30} color="blue" /></div>
                                    <div className='shadow-div'>{trans("steps_create_bg_removal")}</div>
                                </Button>

                                <Button simple={true} onClick={() => this.createNewTemplate(RENDERED_TYPE_AUTOWMREMOVE)} size="big">
                                    <div className='icon-div'><Icon type="eraser-radix" size={30} color="blue" /></div>
                                    <div className='shadow-div'>{trans("steps_create_watermarks")}</div>
                                </Button>

                                <Button simple={true} onClick={() => this.createNewTemplate(RENDERED_TYPE_OUTPAINTING)} size="big">
                                    <div className='icon-div'><IconOutpainting size={30} color={Theme.blue} /></div>
                                    <div className='shadow-div'>{capitalize(trans("outpainting"))}</div>
                                </Button>

                                <Button simple={true} onClick={() => this.createNewVisualSimilarityTemplate()} size="big">
                                    <div className='icon-div'><IconSimilarity size={30} color={Theme.blue} /></div>
                                    <div className='shadow-div'>{trans("visual_similarity")}</div>
                                </Button>
                            </StyledCreateTemplateGrid>

                            <br /><br />
                            <Heading type="4" margin="20px" perex={trans("steps_need_inspiration_perex")}>{trans("steps_need_inspiration")}</Heading>

                            <Gallery />

                            <Div textAlign="center" padding="50px">
                                <Button size="big" icon="chevron-left-light" simple={true} onClick={() => this.setStep(5)}>{trans("previous")}</Button>
                                <Button size="big" icon="check-slim" color="green" onClick={() => this.createNewTemplate(null)}>&nbsp;{trans("create_first_template")}</Button>
                            </Div>
                        </Div>
                    </HeaderGrid>
                </Div>
                </Div>
                </MUSProvider>
        )
    }
}

const Header = css(Heading)({
    margin: "0",
    marginBottom: "0 !important",
    color: "white",
    fontWeight: "normal",
})

const HeaderGrid = css(Grid)({
    gridTemplateColumns: "repeat(6, 100%)",
    valign: "top",
    margin: "0 -50px",
    " > div": {
        width: "100%", maxWidth: "1000px", margin: "auto", marginTop: 0
    },
}, props => ({
    transition: "transform, 0.4s", transform: `translate3d(${(props.step - 1) * (-100) + "%"},0,0)`
}))

const StyledHeading = css(Heading)({
    color: "#374c7c !important",
    position: "absolute",
    top: "-12px",
    fontSize: "32px !important",
})

const StyledCreateTemplateGrid = css(Grid)({
    gridTemplateColumns: "1fr 1fr",
    gridGap: "0px",
    ' .muk-button': {
        display: "grid",
        alignItems: "center",
        gridTemplateColumns: "auto 1fr",
    },
    ' .shadow-div': {
        border: '1px solid #ccc',
        boxShadow: '2px 2px 5px rgba(0,0,0,.1)',
        padding: '15px',
        position: 'relative',
        zIndex: '-1',
        fontWeight: 'bold',
        borderRadius: '0 999em 999em 0',
        fontSize: '14px',
        marginLeft: '-20px',
    },
    ' .icon-div': {
        padding: '20px',
        boxShadow: '2px 2px 5px rgba(0,0,0,.1)',
        border: `1px solid ${Theme.blue}`,
        margin: '1px',
        outlineOffset: '-5px',
        outline: '1px solid #ccc',
        background: 'white',
        borderRadius: '100%',
    }
})

function mapStateToProps(state, props) {
    return {
        project: state.project.data,
        settingsForm: selectFormValues(state, 'settingsForm'),
        subscribe: selectFormValue(state,'newsletter','subscribe'),
        contactEmail: selectFormValue(state,'newsletter','email')
    }
}

export default connect(mapStateToProps, {
    change,
    initForm,
    setProjectToStore,
    createToast,
})(Content)